@if (networkStatus.status()) {
  <div class="network-status-banner" role="status" aria-live="polite">
    {{ message() }}
  </div>
}
